/**
 * Constants for Menu Management
 */
import { ChefHat, Salad, Coffee, IceCream } from "lucide-react";

// Logo Food Truck United pour les menus
export const FTU_LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/a66e27c2-5f47-475e-af5b-7557aec4df08/images/7b8fdfc6926d0c54c9c13a378f45a338278138cf5ead48806b3a320f1bb6b706.png";

// Catégories de plats
export const CATEGORIES = [
  { id: "entree", label: "Entrée", icon: Salad, color: "bg-green-100 text-green-700" },
  { id: "plat", label: "Plat", icon: ChefHat, color: "bg-orange-100 text-orange-700" },
  { id: "dessert", label: "Dessert", icon: IceCream, color: "bg-pink-100 text-pink-700" },
  { id: "boisson", label: "Boisson", icon: Coffee, color: "bg-blue-100 text-blue-700" },
];

// Allergènes standards
export const ALLERGENES = [
  "Gluten", "Crustacés", "Oeufs", "Poisson", "Arachides", "Soja",
  "Lait", "Fruits à coque", "Céleri", "Moutarde", "Sésame",
  "Sulfites", "Lupin", "Mollusques"
];

// Fonds de menu disponibles par pays/thème
export const AVAILABLE_BACKGROUNDS = [
  { id: "france", label: "France", url: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200" },
  { id: "italie", label: "Italie", url: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=1200" },
  { id: "mexique", label: "Mexique", url: "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=1200" },
  { id: "japon", label: "Japon", url: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1200" },
  { id: "inde", label: "Inde", url: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200" },
  { id: "thailande", label: "Thaïlande", url: "https://images.unsplash.com/photo-1528181304800-259b08848526?w=1200" },
  { id: "maroc", label: "Maroc", url: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=1200" },
  { id: "usa", label: "USA", url: "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200" },
  { id: "grece", label: "Grèce", url: "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1200" },
  { id: "vietnam", label: "Vietnam", url: "https://images.unsplash.com/photo-1557750255-c76072a7aad1?w=1200" },
  { id: "espagne", label: "Espagne", url: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=1200" },
  { id: "chine", label: "Chine", url: "https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?w=1200" },
  { id: "default", label: "Neutre", url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200" },
];

// Traductions pour le menu
export const TRANSLATIONS = {
  fr: {
    title: "Notre Carte",
    starters: "Entrées",
    mains: "Plats",
    desserts: "Desserts",
    drinks: "Boissons",
    menus: "Formules",
    allergens: "Allergènes",
    vegetarian: "Végétarien",
    vegan: "Vegan",
    glutenFree: "Sans gluten",
    footer: "Pour toutes allergies, merci de nous consulter",
  },
  en: {
    title: "Our Menu",
    starters: "Starters",
    mains: "Main Courses",
    desserts: "Desserts",
    drinks: "Beverages",
    menus: "Set Menus",
    allergens: "Allergens",
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    glutenFree: "Gluten-free",
    footer: "Please inform us of any allergies",
  }
};

// Traduction des allergènes
export const ALLERGENE_TRANSLATIONS = {
  "Gluten": "Gluten",
  "Crustacés": "Crustaceans",
  "Oeufs": "Eggs",
  "Poisson": "Fish",
  "Arachides": "Peanuts",
  "Soja": "Soy",
  "Lait": "Milk",
  "Fruits à coque": "Tree nuts",
  "Céleri": "Celery",
  "Moutarde": "Mustard",
  "Sésame": "Sesame",
  "Sulfites": "Sulfites",
  "Lupin": "Lupin",
  "Mollusques": "Molluscs"
};

// Template options
export const MENU_TEMPLATES = [
  { id: "classic", label: "Classique", description: "Template élégant traditionnel" },
  { id: "visual-thai", label: "Thai", description: "Style asiatique coloré" },
  { id: "visual-italian", label: "Italien", description: "Ambiance méditerranéenne" },
  { id: "visual-mexican", label: "Mexicain", description: "Couleurs vives et festives" },
  { id: "visual-modern", label: "Moderne", description: "Design minimaliste épuré" },
];
